/** Enum representing reasons for less than required visuals from CT. */
export enum LessThanRequiredVisualsReason {
  REQUESTED_BY_PERSON_ON_SITE = 'REQUESTED_BY_PERSON_ON_SITE',
  WILL_VISIT_AGAIN_TO_TAKE_MISSING_VISUALS = 'WILL_VISIT_AGAIN_TO_TAKE_MISSING_VISUALS',
  PROPERTY_TOO_SMALL = 'PROPERTY_TOO_SMALL',
  PERSON_ON_SITE_WAS_LATE = 'PERSON_ON_SITE_WAS_LATE',
  OTHER = 'OTHER',
}
